import { FC } from 'react';
import { makeStyles } from '@material-ui/core';
import globalStyles from '../../global-styles/rootGlobalStyles';
import { DqText } from '../dq-text';
import classNames from 'classnames';
import './Chip.scss';

/**
 * Props for displaying the chip
 */
export interface ChipProps {
  /**
   * The chip title.
   */
  title?: string;
  /**
   * The chip type
   */
  type?: ChipType;
}

export enum ChipType {
  CONTROLLER_CONNECT = 'CONTROLLER_CONNECT',
  CONTROLLER_CONNECTED = 'CONTROLLER_CONNECTED',
  JOB_COMPLETE = 'JOB_COMPLETE',
  JOB_INPROGRESS = 'JOB_INPROGRESS',
  JOB_LIVE = 'JOB_LIVE',
  ORG_FEATURE_EXPIRED = 'ORG_FEATURE_EXPIRED',
  ORG_FEATURE_ACTIVE = 'ORG_FEATURE_ACTIVE',
  ORG_FEATURE_NA = 'ORG_FEATURE_NA',
}

const useStyles = makeStyles(() => ({
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    display: 'flex',
    background: globalStyles.LightBlue, // update to switch statements once there are more statuses (colors)
    height: globalStyles.Spacing.Six,
    width: 'fit-content',
    paddingLeft: globalStyles.Spacing.Two,
    paddingRight: globalStyles.Spacing.Two,
  },
  chipTitle: {
    fontSize: globalStyles.TextSizes.Fourteen,
    lineHeight: globalStyles.TextSizes.Twenty,
    textAlign: 'center',
    color: globalStyles.UltraDarkGray,
  },
}));

export const Chip: FC<ChipProps> = ({ title, type }) => {
  const classes = useStyles();

  const getBackgroundClass = () => {
    switch (type) {
      case ChipType.CONTROLLER_CONNECT:
        return 'chip-color-grey';
      case ChipType.CONTROLLER_CONNECTED:
      case ChipType.JOB_COMPLETE:
      case ChipType.ORG_FEATURE_NA:
        return 'chip-color-blue';
      case ChipType.JOB_INPROGRESS:
      case ChipType.ORG_FEATURE_ACTIVE:
        return 'chip-color-green';
      case ChipType.JOB_LIVE:
      case ChipType.ORG_FEATURE_EXPIRED:
        return 'chip-color-red';
      default:
        return 'chip-color-grey';
    }
  };

  return (
    <div className={classNames(classes.chip, getBackgroundClass())}>
      <DqText variant="body-small" className={classes.chipTitle}>
        {title}
      </DqText>
    </div>
  );
};
